import axios from 'axios'
import { call, put, takeLatest } from 'redux-saga/effects'

import {
  LIST_EQUIPMENTS_BY_INSURER,
  SET_EQUIPMENTS_BY_INSURER,
} from '@actions/equipment'

import apiConfig from '@services/apiConfig'

import errorHandler from '../errorHandler'

const classPrefix = '/equipment'

function* listEquipmentsByInsurer({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/list-equipment-by-insurer`,
      params
    })
    yield put({ type: SET_EQUIPMENTS_BY_INSURER, data: response.data })
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

export function* listEquipmentsByInsurerSaga() {
  yield takeLatest(LIST_EQUIPMENTS_BY_INSURER, listEquipmentsByInsurer)
}
